module.exports = __webpack_public_path__ + "img/icon-step-4-summary-payment.bb67c380.svg";